import { FC, ReactElement, ReactNode } from 'react';
import i18next from 'i18next';
import { useTenantSettings } from '../../hooks/useTenantSettings';

type TenantSettingsGateProps = {
  children: ReactNode;
}

export const TenantSettingsGate: FC<TenantSettingsGateProps> = ({ children }: TenantSettingsGateProps): ReactElement => {
  const { isLoading, isError, error, data } = useTenantSettings(true);
  
  if (isLoading) {
    return <div>{i18next.t('tenantSettingsGate.loading')}</div>
  }
  
  if (isError) {
    return (
      <div>
        {i18next.t('tenantSettingsGate.error')}
        {error instanceof Error ? ` ${error.message}` : null}
      </div>
    );
  }
  
  if (!data) {
    return <div>{i18next.t('tenantSettingsGate.noDataAvailable')}</div>
  }
  
  return <>{children}</>;
}